import { render, staticRenderFns } from "./WorksItem.vue?vue&type=template&id=6a411805&scoped=true&"
import script from "./WorksItem.vue?vue&type=script&lang=js&"
export * from "./WorksItem.vue?vue&type=script&lang=js&"
import style0 from "./WorksItem.vue?vue&type=style&index=0&id=6a411805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a411805",
  null
  
)

export default component.exports